module.exports = __webpack_public_path__ + "static/media/teacheron.b43c3a26.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/teacheron.svg
// module id = 290
// module chunks = 0